<template>
  <div class="text-item-content">
    <div class="text-title">{{ title }}</div>
    <div class="text-content ProseMirror" v-if="datamodel.value && datamodel.value.content" v-html="datamodel.value && datamodel.value.content"></div>
  </div>
</template>

<script>
export default {
  uuid: "00000000-0000-0000-0000-000000100020",
  components: {},
  props: ["datamodel"],
  data() {
    return {};
  },
  computed: {
    title() {
      if (this.$i18n.locale == "zh-CN") {
        return this.datamodel.zhlabel;
      }
      return this.datamodel.enlabel;
    },
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.text-item-content {
  flex-direction: column;
  .text-title {
    width: 100%;
    padding: 10px 0;
    word-wrap: break-word;
    word-break: keep-all;
    // word-break: break-word;
  }
  .text-content {
    width: 100%;
    padding: 10px 0;
    padding-top: 0px;
  }
}
.ProseMirror {
  min-height: 300px;
  padding: 12px;
  // h1 {
  //   line-height: 2;
  // }
  line-height: 1.6;
  p {
    margin: 0 !important;
  }

  blockquote {
    padding-left: 1rem;
    border-left: 2px solid rgba(#0d0d0d, 0.1);
  }
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 0;
    overflow: hidden;

    td,
    th {
      min-width: 1em;
      border: 2px solid #ced4da !important;
      padding: 3px 5px;
      vertical-align: top;
      box-sizing: border-box;
      position: relative;

      > * {
        margin-bottom: 0;
      }
    }

    th {
      font-weight: bold;
      text-align: left;
      background-color: #f1f3f5 !important;
    }

    .selectedCell:after {
      z-index: 2;
      position: absolute;
      content: '';
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(200, 200, 255, 0.4);
      pointer-events: none;
    }

    .column-resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: -2px;
      width: 4px;
      background-color: #adf;
      pointer-events: none;
    }

    p {
      margin: 0;
    }
  }
  mark {
    background-color: #ffe066;
    padding: 0.125em 0;
    border-radius: 0;
    box-decoration-break: clone;
  }
}
.tableWrapper {
  overflow-x: auto;
}

.resize-cursor {
  cursor: ew-resize;
  cursor: col-resize;
}
</style>
